import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
// import { NzTabPosition } from 'ng-zorro-antd/tabs';


@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  selectedStatus = 1;
  @ViewChildren('detailsContainer') detailsContainers!: QueryList<ElementRef>;
  openedIndex: number | null = null;


  tabs = [
    { label: 'General' },
    { label: 'Pickup' },
    { label: 'Delivery' },
    { label: 'Payments' },
    { label: 'Returns Handling' }
  ];

  summaries = [
    {
      status: 1,
      content: [
        {
          index: '01',
          question: 'What services does PostEx offer?',
          answer: 'PostEx provides a wide range of courier and logistics services, including same-day delivery, next-day delivery, cash on delivery (COD), return management, and international shipping. We also offer financial solutions like early cash settlement for e-commerce businesses.'
        },
        {
          index: '02',
          question: 'How can I track my shipment?',
          answer: 'You can easily track your shipment on our website by entering the tracking number provided to you. You’ll receive real-time updates on the status and location of your parcel.'
        },
        {
          index: '03',
          question: 'What areas do you serve?',
          answer: 'PostEx serves the entire country, covering all major cities and remote areas across Pakistan. We also offer international shipping to various destinations.'
        },
        {
          index: '04',
          question: 'How do I schedule a pickup?',
          answer: 'Scheduling a pickup with PostEx is simple. You can book a pickup through our website, mobile app, or by contacting our customer service. We’ll arrange for a courier to collect your parcel at your convenience.'
        },
        {
          index: '05',
          question: 'What are your delivery times?',
          answer: 'Our standard delivery options include same-day delivery in select cities, next-day delivery nationwide, and international shipping with varying delivery times depending on the destination.'
        }
      ]
    },
    {
      status: 2,
      content: [
        {
          index: '06',
          question: 'Do you offer Cash on Delivery (COD) services?',
          answer: 'Yes, we specialize in COD services, allowing businesses to offer flexible payment options to their customers. We also provide early cash settlement to help businesses manage their cash flow more effectively.'
        },
        {
          index: '07',
          question: 'What payment methods does PostEx accept?',
          answer: 'We accept various payment methods, including cash, credit/debit cards, bank transfers, and mobile wallet payments. For businesses, we offer flexible payment terms and options.'
        },
        {
          index: '08',
          question: 'How can I contact PostEx customer support?',
          answer: 'You can reach our customer support team via phone, email, or through our website’s contact form. Our customer service representatives are available [insert hours] to assist with any inquiries or issues.'
        },
        {
          index: '09',
          question: 'What is the process for handling returns?',
          answer: 'We offer a comprehensive return management solution. If a customer wishes to return a product, we will arrange for pickup and ensure it is safely returned to the sender. Our system tracks returns to provide transparency and efficiency.'
        },
        {
          index: '10',
          question: 'How does PostEx ensure the security of my shipments?',
          answer: 'At PostEx, we take the security of your parcels seriously. We use advanced tracking systems, secure packaging, and rigorous handling protocols to ensure that your shipments arrive safely and in good condition.'
        }
      ]
    },
    {
      status: 3,
      content: [
        {
          index: '11',
          question: 'What should I do if my shipment is delayed or lost?',
          answer: 'If you experience any delays or issues with your shipment, please contact our customer support team immediately. We will investigate the issue and take necessary actions to resolve it as quickly as possible.'
        },
        {
          index: '12',
          question: 'Does PostEx offer international shipping?',
          answer: 'Yes, PostEx provides international shipping services. We work with global partners to ensure reliable and timely delivery to various international destinations.'
        },
        {
          index: '13',
          question: 'How do I become a PostEx business partner?',
          answer: 'To become a PostEx business partner, simply fill out the partnership inquiry form on our website or contact our sales team directly. We’ll discuss your business needs and how PostEx can support your logistics requirements.'
        },
        {
          index: '14',
          question: 'What is your policy on fragile or valuable items?',
          answer: 'For fragile or valuable items, we recommend using our specialized handling services, which include extra protective packaging and insurance options. Please inform us about any special requirements when booking your shipment.'
        },
        {
          index: '15',
          question: 'Can I modify my shipment details after booking?',
          answer: 'Yes, you can modify shipment details such as the delivery address or date after booking, subject to our terms and conditions. Please contact our customer service team as soon as possible to make any changes.'
        }
      ]
    },
    {
      status: 4,
      content: [
        {
          index: '16',
          question: 'How do I cancel a shipment?',
          answer: 'If you need to cancel a shipment, please contact our customer support team promptly. Cancellations may be subject to certain conditions and fees depending on the status of the shipment.'
        },
        {
          index: '17',
          question: 'How do I become a PostEx business partner?',
          answer: 'To become a PostEx business partner, simply fill out the partnership inquiry form on our website or contact our sales team directly. We’ll discuss your business needs and how PostEx can support your logistics requirements.'
        },
        {
          index: '18',
          question: 'What is your policy on fragile or valuable items?',
          answer: 'For fragile or valuable items, we recommend using our specialized handling services, which include extra protective packaging and insurance options. Please inform us about any special requirements when booking your shipment.'
        },
      ]
    },
    {
      status: 5,
      content: [
        {
          index: '19',
          question: 'How do I cancel a shipment?',
          answer: 'If you need to cancel a shipment, please contact our customer support team promptly. Cancellations may be subject to certain conditions and fees depending on the status of the shipment.'
        },
        {
          index: '20',
          question: 'Do you offer Cash on Delivery (COD) services?',
          answer: 'Yes, we specialize in COD services, allowing businesses to offer flexible payment options to their customers. We also provide early cash settlement to help businesses manage their cash flow more effectively.'
        }
      ]
    }
  ];
  ngOnInit(): void {
  }

  changeStatus(status: number) {
    this.selectedStatus = status;
    this.openedIndex = null;

  }

  toggleDetails(index: number): void {
    if (this.openedIndex === index) {
      this.openedIndex = null;
    } else {
      this.openedIndex = index; 
    }
    this.closeOtherSections(index);
  }
  closeOtherSections(currentIndex: number): void {
    this.detailsContainers.forEach((container, i) => {
      if (i !== currentIndex) {
        container.nativeElement.style.maxHeight = '0'; 
      }
    });
  }
}
